import { useIntl } from 'react-intl';
import { generatePath } from 'react-router-dom';
import { ButtonUI, ContextualMenu } from 'sonata-react-components';

import { LineItemsEditButtonsStyled } from '@/components/common/Table/LineItemsButtons/lineItemsEditButtons.styled.ts';
import { isSecondaryActionClick } from '@/helpers/navigation/secondaryAction.helper';
import { useModals, useNavigate } from '@/router';

import type { MouseEvent } from 'react';

import './lineItemsEditButtons.styled.ts';

type Props = {
  id: string;
  lineItem: Record<string, any>;
};

function LineItemsEditButtons({ id, lineItem }: Props) {
  const modals = useModals();
  const navigate = useNavigate();
  const { formatMessage } = useIntl();

  const handleStepsClick = (ev: MouseEvent) => {
    if (isSecondaryActionClick(ev)) {
      window.open(generatePath('/liSettings/edit/:id', { id: lineItem._id }), '_blank', 'noopener,noreferrer');
      return;
    }
    navigate('/liSettings/edit/:id', {
      params: {
        id: lineItem._id
      },
      state: {
        lineItem
      }
    });
  };

  return (
    <LineItemsEditButtonsStyled className="lineItemsEditButtons">
      <ContextualMenu
        buttonConfig={{
          className: 'lineItemsEditButtons__button',
          icon: 'fa-regular fa-pen-to-square',
          shape: 'link',
          size: 'ultraSmall',
          type: 'secondary'
        }}
        id={id}
        placement="bottom"
      >
        <ContextualMenu.Item
          icon="fa-regular fa-pen-to-square"
          id={`${id}-editName`}
          onClick={() =>
            modals.open('/campaigns/new/lineItemSettingsModal', {
              at: {
                pathname: '/campaigns',
                search: location.search
              },
              state: {
                campaignPlanId: lineItem.extraData?.cpId,
                insertionOrderId: lineItem.extraData?.ioId,
                lineItemId: lineItem._id,
                modalId: 'lineItem-modal',
                mode: 'edit',
                showSelectorStep: false
              }
            })
          }
          text={formatMessage({
            defaultMessage: 'Edit Name',
            id: 'lineItems.list.buttons.editName'
          })}
        />
        <ContextualMenu.Item icon="fa-regular fa-pen-to-square" id={`${id}-editSettings`}>
          <span
            onContextMenu={ev => {
              ev.preventDefault();
              handleStepsClick(ev);
            }}
          >
            <ButtonUI
              className="contextualMenuItem__standardButton"
              icon="fa-regular fa-pen-to-square"
              id={`${id}-editSettings`}
              onClick={handleStepsClick}
              shape="link"
              size="ultraSmall"
              text={formatMessage({
                defaultMessage: 'Edit Settings',
                id: 'lineItems.list.buttons.editSettings'
              })}
              type="secondary"
            />
          </span>
        </ContextualMenu.Item>
      </ContextualMenu>
    </LineItemsEditButtonsStyled>
  );
}

export default LineItemsEditButtons;
